export const AddDepartmentModal: string = 'AddDepartmentModal';
